<svg
  class="icon-close"
  [attr.width]="width"
  [attr.height]="height"
  viewBox="0 0 24 24"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M5.29292 5.29292C5.68345 4.9024 6.31661 4.9024 6.70714 5.29292L19.4813 18.0671C19.8719 18.4576 19.8719 19.0908 19.4813 19.4813C19.0908 19.8719 18.4576 19.8719 18.0671 19.4813L5.29292 6.70714C4.9024 6.31661 4.9024 5.68345 5.29292 5.29292Z"
    [attr.fill]="color"
  />
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M5.29289 19.4813C4.90237 19.0908 4.90237 18.4576 5.29289 18.0671L18.0671 5.2929C18.4576 4.90238 19.0908 4.90238 19.4813 5.2929C19.8718 5.68343 19.8718 6.31659 19.4813 6.70711L6.70711 19.4813C6.31658 19.8718 5.68342 19.8718 5.29289 19.4813Z"
    [attr.fill]="color"
  />
</svg>
